module.exports = {
  "metadata": {
    "width": "22",
    "height": "24",
    "name": "info-fill"
  },
  "source": "<path d=\"M22 12A11 11 0 1 1 11 1a11 11 0 0 1 11 11zM11 6.16a1.29 1.29 0 1 0 1.29 1.29A1.29 1.29 0 0 0 11 6.16zm1 10.68V11a1 1 0 1 0-2 0v5.85a1 1 0 0 0 2 0z\"/>"
};